module.exports = __webpack_public_path__ + "img/prize2_active.73998a4.png";